module.exports = __webpack_public_path__ + "img/leg-left-back.0fc733f6.png";